export default __webpack_public_path__ + "1b371b2089496074020f06d4ed356625.png";